var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.targetUser
    ? _c(
        "div",
        {
          style: { height: _vm.size + "px", width: _vm.size + "px" },
          attrs: { id: "avatar-wrapper" },
        },
        [
          _vm.targetUser.gravatar
            ? _c("img", {
                class: {
                  offlineBorder: !_vm.targetUser.isOnline,
                  onlineBorder: _vm.targetUser.isOnline,
                },
                attrs: { src: _vm.targetUser.gravatar, id: "avatar-img" },
              })
            : _c("Avatar", {
                class: {
                  offlineBorder: !_vm.targetUser.isOnline,
                  onlineBorder: _vm.targetUser.isOnline,
                },
                attrs: {
                  username: _vm.targetUser.name || "",
                  id: "avatar-placeholder",
                },
              }),
          _vm._v(" "),
          _vm.targetUser.isOnline
            ? _c("span", { attrs: { id: "online-dot" } })
            : _c("span", { attrs: { id: "offline-dot" } }),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "tippy",
                  rawName: "v-tippy",
                  value: {
                    followCursor: true,
                    placement: "bottom-start",
                  },
                  expression:
                    "{\n                        followCursor: true,\n                        placement: 'bottom-start',\n                    }",
                },
              ],
              staticClass: "name-container",
              attrs: { content: _vm.targetUser.name },
            },
            [
              _vm.isNamed
                ? _c("b", { style: { "font-size": _vm.fontSize + "px" } }, [
                    _vm._v(_vm._s(_vm.targetUser.name)),
                  ])
                : _vm._e(),
            ]
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }